export enum appFields {
  ACHIEVEMENTS_ENABLED = 'achievements_enabled',
  APP_TYPE = 'app_type',
  APPID = 'appid',
  CONTROLLER_SUPPORT = 'controller_support',
  DEVELOPERS = 'developers',
  GENRES = 'genres',
  HDR = 'hdr',
  METASCORE_LINK = 'metascore_link',
  METASCORE = 'metascore',
  MULTIPLAYER = 'multiplayer',
  NAME = 'name',
  OS_LINUX = 'os_linux',
  OS_MAC = 'os_mac',
  OS_WINDOWS = 'os_windows',
  PLAYTIME_FOREVER = 'playtime_forever',
  PRICE_HOURS_RATIO = 'priceHoursRatio',
  PUBLISHERS = 'publishers',
  RELEASE_DATE = 'release_date',
  SIZE_MB = 'size_mb',
  STATS_ENABLED = 'stats_enabled',
  STEAM_CLOUD_ENABLED = 'steamcloud_enabled',
  STORE_PRICE_DEFAULT_USD = 'store_price_default_usd',
  TIME_TO_BEAT = 'time_to_beat',
  TRADING_CARDS_ENABLED = 'tradingcards_enabled',
  WORKSHOP_ENABLED = 'workshop_enabled',
}

// Order affects table column display order
export enum columnComponentNames {
  SELECTION = 'Selection',
  APP_TYPE = 'AppType',
  APP_ID = 'AppId',
  NAME = 'Name',
  TIME_PLAYED = 'TimePlayed',
  TIME_TO_BEAT = 'TimeToBeat',
  STORE_PRICE = 'StorePrice',
  PRICE_HOURS_RATIO = 'PriceHoursRatio',
  METASCORE = 'Metascore',
  RELEASE_DATE = 'ReleaseDate',
  DEVELOPERS = 'Developers',
  PUBLISHERS = 'Publishers',
  OS_WINDOWS = 'OsWindows',
  OS_MAC = 'OsMac',
  OS_LINUX = 'OsLinux',
  INSTALL_SIZES = 'InstallSizes',
  CONTROLLER_SUPPORT = 'ControllerSupport',
  MULTIPLAYER = 'Multiplayer',
  GENRES = 'Genres',
  STEAM_CLOUD_ENABLED = 'SteamCloudEnabled',
  ACHIEVEMENTS_ENABLED = 'AchievementsEnabled',
  TRADING_CARDS_ENABLED = 'TradingCardsEnabled',
  WORKSHOP_ENABLED = 'WorkshopEnabled',
  STATS_ENABLED = 'StatsEnabled',
  HDR_ENBALED = 'HdrEnabled'
}
